import {CookieService} from "ngx-cookie-service";
import {Injectable} from "@angular/core";
import {OcpUtils} from "../../OcpUtils";
import {MainService} from "./main/main.service";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class LangService {
  constructor(private cookieService: CookieService,
              private mainService: MainService,
              public translate: TranslateService) {
  }

  switchLang(lang: string, auth: boolean = true) {
    let useLang = lang === 'kk' ? 'kz' : lang;
    let saveLang = lang === 'kz' ? 'kk' : lang;
    this.translate.setDefaultLang(useLang);
    this.translate.use(useLang);
    if(auth) {
      this.mainService.saveUserLocale(saveLang).subscribe()
    } else {
      let domainCookie = OcpUtils.isProd() ? '.ismet.kz' : '.i-smet.kz';
      let result = new Date();
      result.setDate(result.getDate() + 400) //400 дней (так же приходит с бэка)
      this.cookieService.set('lang', saveLang, result, '/', domainCookie);
    }
  }

  initLang(lang: any, auth: boolean) {
    lang = lang || this.cookieService.get('lang') || 'kk'
    this.switchLang(lang, auth);
  }
}
